import { useRef, useEffect } from 'react';

export const useApiAbort = () => {
    const abortController = useRef<AbortController>(new AbortController());
    const currentSignal = useRef<AbortSignal | null>(null);

    useEffect(() => {
        return () => {
            // Only abort the current pending request, not the global controller
            if (currentSignal.current && !currentSignal.current.aborted) {
                abortController.current.abort();
                // Create new controller for next component instance
                abortController.current = new AbortController();
            }
        };
    }, []);

    const createNewSignal = () => {
        abortController.current = new AbortController();
        currentSignal.current = abortController.current.signal;
        return currentSignal.current;
    };

    return { abortController, createNewSignal, currentSignal };
};

export default useApiAbort;